<template>
    <div class="justify-center text-center py-7 mx-auto white rounded-lg px-4" style="width: 90vw">
      <v-img
          :src="require('../assets/støttelogo.png')"
          class="my-3"
          contain
          height="200"
        />
        <p class="subheading">
          Nu har du mulighed for at bakke endnu mere op om Forældrebevægelsen #HvorErDerEnVoksens arbejde, denne gang også økonomisk.<br/><br/>

          Du kan blive medlem af ”Støtteforeningen for Forældrebevægelsen #HvorErDerEnVoksen”, der findes to typer medlemsskaber:<br/><br/>
        <ul>
          <li>Personligt medlemskab, pris 100 kr. årligt</li>
          <li>Familiemedlemskab, pris 250 kr. årligt</li>
        </ul><br/>
          Støtteforeningens formål er udelukkende at skaffe økonomiske midler til fremtidige aktioner som Forældrebevægelsen #HvorErDerEnVoksen vil stå for.<br/><br/>
          Vores visioner er altid større end vores ressourcer og vi vil følge denne kamp til dørs!
          <br/>
          For at gøre administrationen så enkel som muligt (vi er alle sammen 100% frivillige og ulønnede), har vi valgt at bruge MobilePay til at håndtere kontingentbetalinger, du kan læse mere om betalingsaftaler på mobilepay <a target="_blank" href="https://www.mobilepay.dk/hjaelp/mobilepay-til-private/brug/betalingsaftaler">her</a>.
        </p>
        <br/>
        <v-btn x-large color="accent" dark to="nyt-medlem">Meld dig ind her<v-icon right dark>mdi-arrow-right</v-icon></v-btn>
    <!-- <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/støttelogo.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="my-4">
        <p class="subheading font-weight-regular">
          Nu har du mulighed for at bakke endnu mere op om Forældrebevægelsen #HvorErDerEnVoksens arbejde, denne gang også økonomisk.<br/><br/>

          Du kan blive medlem af ”Støtteforeningen for Forældrebevægelsen #HvorErDerEnVoksen”, der findes to typer medlemsskaber:<br/><br/>
        <ul>
          <li>Personligt medlemskab, pris 100 kr. årligt</li>
          <li>Familiemedlemskab, pris 250 kr. årligt</li>
        </ul><br/>
          Støtteforeningens formål er udelukkende at skaffe økonomiske midler til fremtidige aktioner som Forældrebevægelsen #HvorErDerEnVoksen vil stå for.<br/><br/>
          Vi vil meget gerne være mere uafhængig af andre organisationer økonomisk.
        </p>
        <br/>
        <v-btn x-large rounded color="primary" dark to="nyt-medlem">Meld dig ind her<v-icon right dark>mdi-arrow-right</v-icon></v-btn>
      </v-col>

    </v-row> -->
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({
  })
}
</script>
